import { IFeaturesMap } from 'shared/map-search/types/map';

export function filterPromoPinsByKeys(input: IFeaturesMap, keys: string[]): IFeaturesMap {
  const filteredEntries = Object.entries(input).filter(([key]) => keys.some(substring => key.includes(substring)));

  return Object.fromEntries(filteredEntries);
}
